import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3l18 18","key":"svg-0"}],["path",{"d":"M14.828 9.172a4 4 0 0 1 1.172 2.828","key":"svg-1"}],["path",{"d":"M17.657 6.343a8 8 0 0 1 1.635 8.952","key":"svg-2"}],["path",{"d":"M9.168 14.828a4 4 0 0 1 0 -5.656","key":"svg-3"}],["path",{"d":"M6.337 17.657a8 8 0 0 1 0 -11.314","key":"svg-4"}]]

const IconAccessPointOff = createReactComponent('outline', 'access-point-off', 'AccessPointOff', __iconNode);

export default IconAccessPointOff;